import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterModaliteReunionByNamePipe } from 'src/app/shared/pipes/filter-modaliteReunion-by-name/filter-modaliteReunion-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { ModaliteReunionModalDetailComponent } from './modal/modaliteReunion-modal-detail/modaliteReunion-modal-detail.component';
import { ModaliteReunionModalAjoutComponent } from './modal/modaliteReunion-modal-ajout/modaliteReunion-modal-ajout.component';
import { ListModaliteReunionComponent } from './list-modaliteReunion/list-modaliteReunion.component';

@NgModule({
	declarations: [
		ListModaliteReunionComponent,
		ModaliteReunionModalDetailComponent,
		ModaliteReunionModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterModaliteReunionByNamePipe]
})

export class ModaliteReunionModule {}
